import DeliveredMealReviewModal from 'components/common/modals/DeliveredMealReviewModal';
import TempoTaggedReviewModal from 'components/common/modals/TempoTaggedReviewModal';
import * as Types from 'utilities/types';

const ReviewModalContainer = ({
  existingReview,
  isModalOpen,
  shouldShowTempoTaggedReviewModal,
  initialRating,
  mealId,
  menuId,
  onClose,
  onShowToast,
  photoSrc,
  title,
  ratingSubmittedEvent,
  reviewSubmittedEvent,
}) => {
  return shouldShowTempoTaggedReviewModal ? (
    <TempoTaggedReviewModal
      isOpen={isModalOpen}
      onClose={onClose}
      mealId={mealId}
      menuId={menuId}
      title={title}
      photoSrc={photoSrc}
      existingReview={existingReview}
      onShowToast={onShowToast}
      ratingSubmittedEvent={ratingSubmittedEvent}
      reviewSubmittedEvent={reviewSubmittedEvent}
    />
  ) : (
    <DeliveredMealReviewModal
      isOpen={isModalOpen}
      onClose={onClose}
      mealId={mealId}
      menuId={menuId}
      title={title}
      initialRating={initialRating}
      existingReview={existingReview}
      onShowToast={onShowToast}
      ratingSubmittedEvent={ratingSubmittedEvent}
      reviewSubmittedEvent={reviewSubmittedEvent}
    />
  );
};

ReviewModalContainer.propTypes = {
  existingReview: Types.review,
  isModalOpen: PropTypes.bool.isRequired,
  shouldShowTempoTaggedReviewModal: PropTypes.bool.isRequired,
  initialRating: PropTypes.number,
  mealId: PropTypes.string.isRequired,
  menuId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onShowToast: PropTypes.func.isRequired,
  photoSrc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  ratingSubmittedEvent: PropTypes.string,
  reviewSubmittedEvent: PropTypes.string,
};

export default ReviewModalContainer;
